<template>
    <div class="section_1 flex-col">
        <div class="box_3 flex-col">
          <img
              class="image_3"
              referrerpolicy="no-referrer"
              src="../assets/img/8a6732519651d3e286deb7c7f95dc01d.webp"
          />
          <span class="text_7">企业构想</span>
          <div class="text-wrapper_1">
            <span class="text_8">海南鼎言智造商业管理有限公司立足于重庆，致力于成为</span>
            <span class="text_9">全国TOP级校园全维度服务管家和最受客户及合作伙伴信赖的校园服务运营机构</span>
            <span class="text_10">
            。我们的服务范围涵盖高校食堂、超市、商业配套及后勤综合管理，旨在为师生创造舒适、便捷、安全的校园环境。我们的企业构想是构建一个“智慧后勤，绿色校园”的服务体系，我们将聚焦于为各类高校提供战略规划、运营管理、人力资源等一站式服务，帮助高校打造更便捷的校园环境和营造良好的口碑，提升招生指标。我们将搭建食堂、超市独有的供应链，在供应商选择、采购管理、库存管理、物流配送以及供应链优化与改进等方面做出系统性的规划和实施。通过整合各方资源，实现供应链的协同运作，为食堂、超市提供稳定、高效、安全的食材和商品供应。培养一支经验丰富、专业素养高的团队，能够深入理解客户需求，提供量身定制的解决方案，为客户创造更大的价值。同时，我们注重与客户的长期合作和共同发展，建立稳固的合作关系，实现共赢，助力企业在竞争激烈的市场中取得优势地位。
          </span>
          </div>
          <div class="block_1 flex-row justify-between">
            <div class="text-wrapper_2 flex-col"><span class="text_11">食堂运营</span></div>
            <div class="text-wrapper_3 flex-col"><span class="text_12">商贸运营</span></div>
            <div class="text-wrapper_4 flex-col"><span class="text_13">商业运营</span></div>
          </div>
          <span class="text_14">企业现状</span>
          <span class="text_15">
          公司创始人具有高校后勤及商业服务十七年的管理经验，公司现有员工300余人，服务高校12余所，项目服务人次逾30万，服务总面积超50000平方米，以专业的口碑和良好的信誉立足于行业发展的前端。
        </span>
          <div class="block_2 flex-row justify-between">
            <div class="text-wrapper_5 flex-col" style="cursor: pointer" @click="handleClick(1)"><span class="text_16">团队</span></div>
            <div class="text-wrapper_6 flex-col" style="cursor: pointer" @click="handleClick(2)"><span class="text_17">行业分析</span></div>
            <div class="text-wrapper_7 flex-col" style="cursor: pointer" @click="handleClick(3)"><span class="text_18">竞品分析</span></div>
            <div class="text-wrapper_8 flex-col" style="cursor: pointer" @click="handleClick(4)"><span class="text_19">产品与服务</span></div>
            <div class="text-wrapper_9 flex-col" style="cursor: pointer" @click="handleClick(5)"><span class="text_20">运营规划</span></div>
          </div>
          <div class="block_3 flex-row justify-between">
            <div class="text-wrapper_10 flex-col" style="cursor: pointer" @click="handleClick(6)"><span class="text_21">销售渠道</span></div>
          </div>
          <span class="text_23">企业领域</span>
          <div class="text-wrapper_12">
            <span class="text_24">公司立足重庆，辐射西部，</span>
            <span class="text_25">
            市场领域分布在重庆、江苏、河南、河北、江西、湖南、广东等全国10个省、直辖市、自治区，服务项目近12余个，未来还会有更多领域待辐射。
          </span>
          </div>
          <img
              class="image_4"
              referrerpolicy="no-referrer"
              src="../assets/img/b00d0b06fba788eb4a3c4385f9bf38d6.webp"
          />
          <span class="text_26">市场规模</span>
          <div class="text-wrapper_13">
          <span class="paragraph_1">
            高等院校每年入学预估值为：结合过去15年国内人口出生率，预判未来15年约每年超过1000万人学生将接受高等教育或职业教育。高中、初中每年入学预估值：未来15年约每年超过1500-1800万人学生将接受中等教育或职业技能培训，整体消费市场规模2.5亿人（6-22岁）。
            <br />
            公司3-5年市场规模预期:20--50个校区项目，总投资额2-5亿（滚动投资），三年后年销售收入15亿-30亿，自营部分毛利率30-35%，其它外包部分毛利率10-30%。综合纯利润约10-15%。单个项目投资成本回报周期不超过18个月，成本回收完成后，回报率不少于初期投资额的30-50%/年。
            <br />
            高等院校按平均每位在校生年消费15000-20000元计费，高等院校类的规模为5000万人（含研究生、本科、专科）*20000元/年消费。则每年市场规模为10000亿元。
            <br />
            高中或初中等校区及职业技能培训的在校生，按平均每位在校生年消费10000-15000元计费，规模为1亿人（含高中、初中、技能培训）*13000元/年消费。则每年市场规模为13000亿元。
            <br />
            <br />
          </span>
            <span class="paragraph_2"><br /></span>
          </div>
          <img
              class="image_5"
              referrerpolicy="no-referrer"
              src="../assets/img/18f4cfbeabe5c822fd2dabd331b5e45a.webp"
          />
        </div>
      </div>
</template>
<script>
  export default {
    data() {
      return {
        constants: {}
      };
    },
    emits: ['select'],
    methods: {
      handleClick(value) {
        this.$emit('select', value);
      }
    }
  };
</script>
<style scoped lang="css" src="../assets/index.css" />
